import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Checkbox } from 'antd';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';

const UnassignedDishesCheckBox: React.FC = () => {
	const {
		toggleUnassignedDishes,
		isUnassignedDishes,
		IDSelectedCustomer,
		IDSelectedRestaurant,
		IDSelectedCategory,
		IDSelectedSubCategory,
	} = useContext<IDishesContext>(DishesContext);

	useEffect(() => {
		if (isUnassignedDishes && IDSelectedCategory) {
			toggleUnassignedDishes();
		}
	}, [IDSelectedCategory]);

	return (
		<Checkbox
			onChange={toggleUnassignedDishes}
			checked={isUnassignedDishes}
			disabled={!!IDSelectedCategory || !!IDSelectedSubCategory || !IDSelectedCustomer || !IDSelectedRestaurant}
			data-test="UnassignedDishesCheckBox">
			<Text translationNameSpace="listing" translationKey="unassignedDishesLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedDishesCheckBox;
